/* Smooth open/close for the Collapsible content section.
   Progressive enhancement over native <details class="accordion">: the native
   `open` attribute stays the source of truth (so keyboard and screen-reader
   semantics are unchanged); we only animate the height with the Web Animations
   API. If this script never runs, the accordion still opens/closes natively.
   Honors prefers-reduced-motion. */
(function () {
  var DURATION = 320;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function AccordionAnimator(details) {
    this.details = details;
    this.summary = details.querySelector('summary');
    this.content = details.querySelector('.accordion__content');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    if (!this.summary || !this.content) return;
    this.summary.addEventListener('click', this.onClick.bind(this));
  }

  AccordionAnimator.prototype.onClick = function (event) {
    // Let the browser toggle natively when motion is reduced.
    if (reduceMotion.matches) return;
    event.preventDefault();
    this.details.style.overflow = 'hidden';
    if (this.isClosing || !this.details.open) {
      this.open();
    } else if (this.isExpanding || this.details.open) {
      this.shrink();
    }
  };

  AccordionAnimator.prototype.shrink = function () {
    this.isClosing = true;
    var start = this.details.offsetHeight;
    var styles = getComputedStyle(this.details);
    var chrome =
      parseFloat(styles.paddingTop) +
      parseFloat(styles.paddingBottom) +
      parseFloat(styles.borderTopWidth) +
      parseFloat(styles.borderBottomWidth);
    var end = this.summary.offsetHeight + chrome;
    this.run(start, end, false);
  };

  AccordionAnimator.prototype.open = function () {
    this.details.style.height = this.details.offsetHeight + 'px';
    this.details.open = true;
    window.requestAnimationFrame(this.expand.bind(this));
  };

  AccordionAnimator.prototype.expand = function () {
    this.isExpanding = true;
    var start = this.details.offsetHeight;
    // Measure the natural expanded height (includes content margins + accordion padding).
    this.details.style.height = 'auto';
    var end = this.details.offsetHeight;
    this.details.style.height = start + 'px';
    this.run(start, end, true);
  };

  AccordionAnimator.prototype.run = function (start, end, open) {
    if (this.animation) this.animation.cancel();
    this.animation = this.details.animate(
      { height: [start + 'px', end + 'px'] },
      { duration: DURATION, easing: 'ease' }
    );
    var self = this;
    this.animation.onfinish = function () {
      self.finish(open);
    };
    this.animation.oncancel = function () {
      self.isClosing = false;
      self.isExpanding = false;
    };
  };

  AccordionAnimator.prototype.finish = function (open) {
    this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.details.style.height = '';
    this.details.style.overflow = '';
  };

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('.collapsible-content-section details.accordion').forEach(function (details) {
      if (details.dataset.accordionAnimated) return;
      details.dataset.accordionAnimated = 'true';
      new AccordionAnimator(details);
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  }
  // Re-init blocks added/reloaded in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
